import { createListCollection, Select } from '@chakra-ui/react';
import ApplicationErrorView from '@packages/charka-common-ui/graphql/error/application-error-view';
import { useFocusedBranchContext } from '@packages/core/branch/focused-branch-context';
import { useTranslate } from '@tolgee/react';
import usePrinterDevices from '../logic/use-printer-device';

export default function PrinterDeviceSelection(props: {
  printerDeviceId: string | undefined;
  onChange: (printerId: string) => void;
}) {
  const branch = useFocusedBranchContext();
  const { data, error, loading } = usePrinterDevices(branch.branch?.id ?? '');
  const { t } = useTranslate();

  if (loading) {
    return null;
  }

  const printerData = createListCollection({
    items: [
      { label: t('no-printer-select', 'No printer select'), value: '' },
      ...(data?.printerDevices.map((printer) => ({
        label: printer.name,
        value: printer.id,
      })) ?? []),
    ],
  });

  return (
    <>
      <ApplicationErrorView error={error} />
      <Select.Root
        defaultValue={props.printerDeviceId ? [props.printerDeviceId] : []}
        onValueChange={({ value }) => {
          props.onChange(value.at(0) ?? '');
        }}
        border={'solid 1px'}
        borderColor={'gray.500'}
        collection={printerData}
        size="sm"
      >
        <Select.HiddenSelect />
        <Select.Control>
          <Select.Trigger>
            <Select.ValueText px={2} placeholder={t('page-rule.printer.placeholder', 'Select printer')} />
          </Select.Trigger>
          <Select.IndicatorGroup>
            <Select.Indicator />
          </Select.IndicatorGroup>
        </Select.Control>
        <Select.Positioner>
          <Select.Content>
            {printerData.items.map((framework) => (
              <Select.Item zIndex={50} item={framework} key={framework.value}>
                {framework.label}
                <Select.ItemIndicator />
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Select.Root>
    </>
  );
}
